module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_ryspot_1.042ba8e2.jpg";